const rulesProps = {
  props: [
    'ruleType',
    'ruleAction',
    'ruleContent',
    'ruleKey',
    'ruleValue',
    'ruleName',
    'ruleDisabled',
    'rulePlaceholder',
  ],
};

export default rulesProps;
